export const TITLE = "Archived Opportunities";
export const SUBTITLE = "By archive reason";
export const EMPTY_TITLE = "Nothing Archived Yet";
export const EMPTY_BODY =
  "Won, lost, and no-bid outcomes will summarize here.";
export const MAX_VISIBLE_REASONS = 6;

export const REASON_COLORS = [
  "var(--token-border-primary-800)",
  "var(--token-border-primary-600)",
  "var(--token-border-primary-400)",
  "var(--token-border-primary-300)",
  "var(--token-border-primary-200)",
  "var(--token-surface-primary-150)",
];
export const OTHERS_COLOR = "var(--token-surface-gray-200)";

export const colorFor = (reason, index) =>
  reason.statusId === "others" ? OTHERS_COLOR : REASON_COLORS[index % REASON_COLORS.length];

export const othersLabel = (n) => `and ${n} ${n === 1 ? "other" : "others"}`;

export const viewAllLabel = (n) =>
  `View all ${n} ${n === 1 ? "reason" : "reasons"}`;

export const buildVisibleReasons = (reasons) => {
  if (reasons.length <= MAX_VISIBLE_REASONS) {
    return reasons;
  }
  const visible = reasons.slice(0, MAX_VISIBLE_REASONS);
  const rest = reasons.slice(MAX_VISIBLE_REASONS);
  const restCount = rest.reduce((sum, reason) => sum + reason.count, 0);
  return [
    ...visible,
    { statusId: "others", statusName: othersLabel(rest.length), count: restCount },
  ];
};
